import { render, staticRenderFns } from "./BarcodeReader.vue?vue&type=template&id=54046772&scoped=true&"
import script from "./BarcodeReader.vue?vue&type=script&lang=js&"
export * from "./BarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeReader.vue?vue&type=style&index=0&id=54046772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54046772",
  null
  
)

export default component.exports